import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TripHistoryComponent } from './trip-history.component';
import {AgGridModule} from 'ag-grid-angular';
import {FormsModule} from '@angular/forms';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import {ReservationService} from '../reservations.service';
import {GridComponentsModule} from '../../A2-utils/grid-components/grid-components.module';
import {BooleanCheckComponent} from '../../A2-utils/grid-components/boolean-check/boolean-check.component';
import {DirectivesModule} from '../../../directives/directives.module';
import {MasiveCancelTripsModule} from '../../A2-utils/masive-cancel-trips/masive-cancel-trips.module';
import { GridLayoutMenuModule } from '../../../utils/grid-layout-menu/grid-layout-menu.module';


@NgModule({
    imports: [
        CommonModule,
        AgGridModule.withComponents([BooleanCheckComponent]),
        FormsModule,
        Trip2ThemeModule,
        GridComponentsModule,
        DirectivesModule,
        MasiveCancelTripsModule,
        GridLayoutMenuModule,
    ],
  declarations: [
      TripHistoryComponent
  ],
  exports: [
      TripHistoryComponent
  ],
    providers: [
        ReservationService
    ]
})
export class TripHistoryModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/trip-history/trip-history.module.ts